import { Box, styled } from '@mui/material'
import AboutUs from 'api/admin/clinic-manage/about.api'
import Loading from 'component/Loading'
import LabOrderQueue from 'features/lab-order/lab-order-queue'
import { useEffect, useState } from 'react'
import { getBranch } from 'utils/app.utils'
import LabOrderList from './lab-order-list'

export const LabCustomComponent = styled(Box)<{ type: 'queue' | 'list' }>(({ theme, type }) => ({
  maxWidth: type === 'queue' ? '524px' : '100%'
}))

export default function LabOrder() {
  const [reloadQueue, setReloadQueue] = useState<boolean>(false)
  const [reloadList, setReloadList] = useState<boolean>(false)

  const branchId = getBranch()
  const [branch, setBranch] = useState<any>()
  const [isLoading, setIsLoading] = useState<boolean>(true) // 1. เพิ่ม State สำหรับ Loading


  const loadBranchInfo = () => {
    AboutUs.detailClinic(Number(branchId))
      .then(({ data }) => {
        setBranch(data)
      })
      .catch((e) => {
        return
      }).finally(() => {
        setIsLoading(false)
      })
  }

  useEffect(() => {
    loadBranchInfo()
  }, [branchId])

  return (
    <div className="p-3 h-100">
      <Loading show={isLoading} />
      <Box className="d-lg-flex flex-row h-100 w-100">
        <LabCustomComponent type="queue" className="w-100 h-100" sx={{ flex: 'none' }}>
          <LabOrderQueue
            branch={branch}
            reload={() => setReloadList(!reloadList)}
            valReload={reloadQueue}
          reloadQueue={(val: boolean) => setReloadList(val)} 
          />
        </LabCustomComponent>
        <LabCustomComponent type="list" className="w-100 overflow-hidden mt-3 mt-lg-0">
          <LabOrderList
            reload={() => setReloadQueue(!reloadQueue)}
            valReload={reloadList}
          reloadQueue={(val: boolean) => setReloadQueue(val)}
          />
        </LabCustomComponent>
      </Box>
    </div>
  )
}
